import { PropsWithChildren } from "react";

export const IntroductionText = ({ children }: PropsWithChildren) => (
  <div className="flex w-full flex-col gap-3.5 leading-5 text-gray-70">
    {children}
  </div>
);
